// my-theme.ts
import { em } from "polished";
import { DefaultTheme } from "styled-components";

const white = "#fff";
const black = "#242424";
const blue = "#0050ff";
const darkPink = "#e90052";
const fantasy = "#00ff87";
const greyLight = "#dadada";
const primary = "#001e50";
const primaryTwo = "#00235a";
const primaryThree = "#001941";
const secondary = "#f0f4fd";
const secondaryTwo = "#dde4f0";
const secondaryThree = "#1c396c";
const yellow = "#ffd600";
const primaryYellow = "#fecb01";
const secondaryYellow = "#ffbf00";
const whiteGrey = "#e8e8ea";
const grey04 = "rgba(200, 200, 200, 0.4)";
const green = "#a4ff01";
const accentRed = "#e10114";
const accentRedTwo = "#ea4a4b";
const blurBackground =
  "linear-gradient(75deg,rgba(255, 255, 255, 0.3) 2.88%,rgba(255, 255, 255, 0) 88.14%)";

const theme: DefaultTheme = {
  borders: [
    `1px solid ${secondaryTwo}`,
    `1px solid ${secondary}`,
    `1px solid ${whiteGrey}`,
    `1px solid ${primary}`,
    `2px solid ${secondaryTwo}`,
    `2px solid ${white}`,
    `1px solid ${grey04}`,
  ],
  breakpoints: [
    em("400px"),
    em("610px"),
    em("700px"),
    em("900px"),
    em("1024px"),
    em("1220px"),
  ],
  colors: {
    accentRed,
    accentRedTwo,
    white,
    black,
    blue,
    blueDark: "#0037af",
    darkPink,
    difficulties: {
      1: {
        bg: "#257d5a",
        color: "white",
      },
      2: {
        bg: "#00ff86",
        color: "black",
      },
      3: {
        bg: "#ebebe4",
        color: "black",
      },
      4: {
        bg: "#ff005a",
        color: "white",
      },
      5: {
        bg: "#861d46",
        color: "white",
      },
    },
    elementStatus: {
      0: {
        bg: "#c0020d",
        color: "white",
      },
      25: {
        bg: "#d44401",
        color: "white",
      },
      50: {
        bg: "#ffab1b",
        color: black,
      },
      75: {
        bg: "#ffe65b",
        color: black,
      },
    },
    elementTypes: {
      1: {
        bg: yellow,
        color: primary,
      },
      2: {
        bg: fantasy,
        color: primary,
      },
      3: {
        bg: blue,
        color: primary,
      },
      4: {
        bg: darkPink,
        color: "white",
      },
    },
    error: "#e02200",
    fantasy,
    green,
    greenDark: "#93e400",
    grey: "#e7e7e7",
    greyDark: "#535353",
    greyLight,
    greyLight2: "#c9ced6",
    greyLight3: "#f7f7f7",
    pink: "#ff2882",
    primary,
    primaryTwo,
    primaryThree,
    secondary,
    secondaryTwo,
    secondaryThree,
    greyDarker1: "#e5e5e5",
    greyDarker2: "#e0e0e0",
    greyDarker3: "#6E6E6E",
    blueDarker1: "#3069a5",
    blueDarker2: "#004986",
    blueDarker3: "#14253c",
    blueDarker4: "#161619",
    social: {
      facebook: {
        bg: "#3b5998",
        color: "white",
      },
      twitter: {
        bg: "#00aced",
        color: "white",
      },
      google: {
        bg: "white",
        color: "rgba(0, 0, 0, 0.54)",
      },
    },
    success: "#067a5e",
    tertiary: "#d2eff9",
    text: black,
    whiteBlue: "#f2f9fa",
    whiteGrey,
    yellow,
    primaryYellow,
    secondaryYellow,
    yellowLight: "#fff59c",
    blurBackground,
  },
  fontSizes: [
    "1.2rem",
    "1.3rem",
    "1.4rem",
    "1.6rem",
    "1.8rem",
    "2rem",
    "2.4rem",
    "2.6rem",
    "3.2rem",
  ],
  fonts: {
    base: '"Source Sans 3", Helvetica, Arial, sans-serif',
    impact: '"LigaPortugal Regular", Helvetica, Arial, sans-serif',
  },
  radii: ["2px", "5px", "10px", "50px"],
  space: ["0", "0.5rem", "1rem", "1.5rem", "2rem", "2.5rem", "3rem"],
  zIndex: {
    clientMenu: 7000,
    dialog: 9000,
    menu: 6000,
    overlay: 8000,
    select: {
      select: 50,
      wrap: 40,
    },
  },
};

export default theme;
